import React from 'react';

const VenueSearchResultItem = ({ row, onSelect }) => {
  const placeName = String(row?.placeName || '').trim();
  const address = String(row?.roadAddress || row?.jibunAddress || '').trim();
  const sub = String(row?.jibunAddress || '').trim();

  return (
    <button
      type="button"
      className="w-full text-left p-4 hover:bg-muted transition-athletic"
      onClick={() => onSelect?.(row)}
    >
      {placeName && <p className="text-sm font-semibold text-foreground">{placeName}</p>}
      <p className="text-sm font-medium text-foreground">{address || '주소'}</p>
      {sub && sub !== address && <p className="text-xs caption text-muted-foreground mt-1">{sub}</p>}
      <p className="text-xs caption text-muted-foreground mt-1">
        위치: {row?.y}, {row?.x}
      </p>
    </button>
  );
};

export default VenueSearchResultItem;
